import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NavLink, NavRoleMapping, NavRoles } from '../navigation/navigation.models';
import { NavigationService } from '../navigation/navigation.service';
import { AlertService } from '../alert/alert.service';
interface DataItem {
  source: string;
  // other properties
}

@Component({
  selector: 'app-dynamic-role-mapping',
  templateUrl: './dynamic-role-mapping.component.html',
  styleUrls: ['./dynamic-role-mapping.component.scss']
})
export class DynamicRoleMappingComponent implements OnInit {
  public form: FormGroup;
  roleMapping :any [] = [];
  searchFilter: any = {};
  public parent: any[];
  public common: any;
  subscription: Subscription;
  public DataMap: NavLink[] = [];
  public data: any[] = [];
  public roles: any[] = [];
  public heading: boolean = true;
  public DataNavRoles: any[] = [];
  public data1: NavLink[] = [];
  public existingnavroles: NavRoleMapping[] = [];
  public existingnavlinks: any[] = [];
  public navdemo: any[] = []
  public rolesflt: any;
  public parentflt: any;
  public childflt: any;
  public RoleListCtrl: FormControl = new FormControl();
  public LinkListCtrl: FormControl = new FormControl();
  private _onDestroy = new Subject<void>();
  public datan: any[] = [];
  source: any;
  sourceFiltered: any;
  closeFormData: any = false;
  Source = [
    {
      id: 'NONE',
      name: 'NONE'
    },
    {
      id: 'ERP',
      name: 'ERP'
    },
    {
      id: 'LCP',
      name: 'LCP'
    }
  ]
  filterData: any[];
  allSelectedRoleData: any;
  isroleMappingForm: boolean = true;
  roleScreen = 'Role-Mapping';
  navLinkRoleId: any;
  filteredListData: any;
  workOrderTableSettings: any;
  editRolesdata: any;
  OrignalData: any[];
  Navlinkmap: any[] = [];

  constructor(
    public fb: FormBuilder,
    public navservice: NavigationService,
    public alertService: AlertService,
  ) {
    
    this.subscription = this.navservice.rolesub$.subscribe((val) => {
      
      this.common = val;
      this.common.Navlinkmap = this.common.Navlinkmap;
      this.RoleListCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe((val) => {
          this.roles = this.searchRoleList(val);
        });
      this.LinkListCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe((val) => {
          this.data = this.searchLinkList(val);
        });
      if (this.common.Isdialog == false) {
        this.heading = false;
      }
    });
    this.navservice.allRole$.subscribe((val) => {
      this.allSelectedRoleData = val;
      console.log(this.allSelectedRoleData);
    });

    if (this.common) {
      this.GetAllNavLink();
    } else {
      if (this.common == undefined || this.common.NavLinkRoleId == null) {
        var a = new NavRoleMapping();
        this.common = a;
      }
    }
    this.form = this.fb.group({
      roleId: [null, Validators.compose([Validators.required])]
    })

    this.RoleListCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(val => {
        this.roles = this.searchRoleList(val);
      });

    this.LinkListCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(val => {
        this.data = this.searchLinkList(val);
      });
  }

  ngOnInit(): void {
    
    this.GetAllRoles();
    this.source = 'LCP';
    this.sourceFiltered = 'lcp';
    this.GetAllNavRolesMap();
    this.GetAllNavLink();
  }

  GetAllNavRolesMap() {
    let obj = {
      Linkname:  null,
      Rolename: null,
      Source:  "LCP"
    }
    this.navservice.listNavMapRolesData(obj)
      .subscribe(data => {
        if (data) {
          this.DataNavRoles = data as Array<NavRoleMapping>;
          this.OrignalData = this.DataNavRoles;
          this.datan = this.OrignalData;
          if (this.datan) {
            for (let a = 0; a < this.datan.length; a++) {
              this.Navlinkmap.push(this.datan[a].navLinkId);
            }
          }
        }
      });
  }


  GetAllRoles() {
    this.navservice.listNavRolesData()
      .subscribe(data => {
        if (data) {
          this.roles = data as Array<NavRoles>;
          this.rolesflt = this.roles;
          if (this.editRolesdata && this.editRolesdata.data.roleId) {
            this.form.get("roleId")?.patchValue(this.editRolesdata?.data?.roleId.toLowerCase());
          }
        }
      });
  }


  GetAllNavLink() {
    let obj = {}
    this.navservice.listNavLinkData(obj)
      .subscribe(data => {
        if (data) {
          this.DataMap = data as Array<NavLink>;
          this.data = this.DataMap; // only display lcp record first time
          this.filterData = this.DataMap;
          if (this.editRolesdata?.data?.roleId) {
            this.data.forEach(item => {
              this.Navlinkmap.forEach(ele => {
                if (item.navLinkId == ele) {
                  item['isAdmin'] = true;
                }
              })
            })
          }
          this.data1 = this.data;
        }
      });
  }

  // change the Source data
  changeSource(event: any) {
    let filter = event.value.toLowerCase();
    this.sourceFiltered = filter;
    if (filter == 'none') {
      this.data = this.filterData;
    } else {
      this.data = this.filterData.filter((n:any) => (n.source != null));
    }
  }

  searchRoleList(value: string) {
    let filter = value.toLowerCase();
    this.parentflt = this.rolesflt;
    return this.parentflt.filter((n:any) => n.name.toLowerCase().includes(filter));
  }

  searchLinkList(value: string) {
    let filter = value.toLowerCase();
    if (this.sourceFiltered == 'lcp') {
      let lcpData = this.DataMap.filter(item => item.source == 'LCP');
      this.childflt = lcpData;
      return this.childflt.filter((n:any) => n.title.toLowerCase().includes(filter));
    } else if (this.sourceFiltered == 'erp') {
      let erpData = this.DataMap.filter(item => item.source == 'ERP');
      this.childflt = erpData;
      return this.childflt.filter((n:any) => n.title.toLowerCase().includes(filter));
    } else {
      return this.filterData.filter((n:any) => n.title.toLowerCase().includes(filter));
    }
  }

  // This function is used for select the check and uncheck data
  getCheckedValue(event:any, value:any) {
    if (event.target.checked) {
      if (this.Navlinkmap && this.editRolesdata?.data?.roleId) {
        this.Navlinkmap.push(value.navLinkId)
      } else {
        this.roleMapping.push(value.navLinkId)
      }
    } else {
      if (this.Navlinkmap && this.editRolesdata?.data?.roleId) {
        let a = this.Navlinkmap.indexOf(value.navLinkId);
        this.Navlinkmap.splice(a, 1)
      } else {
        let a = this.roleMapping.indexOf(value.navLinkId);
        this.roleMapping.splice(a, 1)
      }
    }
  }


  // This function is used for submit the data
  onUserSubmit(values: Object): void {
    
    if (this.form.valid) {
      const user = new NavRoleMapping();
      Object.assign(user, this.form.getRawValue());
      if (this.Navlinkmap && this.editRolesdata?.data?.roleId) {
        user.navlinkmap = this.Navlinkmap;
      } else {
        user.navlinkmap = this.roleMapping;
      }
      if (this.navLinkRoleId != '0') {
        user.NavLinkRoleId = this.navLinkRoleId;
        this.navservice.UpdateNavRole(user)
          .subscribe(
            data => {
              this.alertService.success('Record Update successfully.');
              this.closeDialog();
            },
            error => {
              this.alertService.error('Navigation Role update Error');
            }
          );

      } else {
        this.navservice.AddNavRole(user)
          .subscribe(
            data => {
              this.alertService.success('Record saved successfully.');
              this.closeDialog();
            },
            error => {
              this.alertService.error('Navigation Role Save Error');
            }
          );
      }

    } else {
      Object.keys(this.form.controls).forEach(key => {
        this.form.controls[key].markAsTouched({ onlySelf: true });
      });
    }
  }

  closeDialog() {
    this.closeFormData = true;
    this.isroleMappingForm = true;
    this.getAllRoleMapping()
  }

  getAllRoleMapping() {
    let request = {
      URLFilter: "",
      isActive: true,
      isDeleted: false,
      page: "1",
      pageSize: "50"
    }
    this.navservice.listNavMapRolesData(request).subscribe(Response => {
      this.filteredListData = Response
      
    })
  }

  getAllMappingList(x:any) {
    this.workOrderTableSettings = x;
    setTimeout(() => {
      var dynamicData = {
        id: this.workOrderTableSettings.element.id,
        name: this.workOrderTableSettings.element.id,
        fromId: this.workOrderTableSettings.element.id,
        fromName: this.workOrderTableSettings.element.id,
        data: this.filteredListData || []
      }
      this.closeFormData = true
    }, 1000)
  }

}
